// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3XPjn","right":"styles_right__35bU6"};